import React from 'react';
import { Cell, Pie, PieChart, ResponsiveContainer } from 'recharts';

import { brandColors } from '@/app/constants';

interface ChurnRiskIndicatorProps {
  score: number;
}

const ChurnRiskIndicator: React.FC<ChurnRiskIndicatorProps> = ({ score }) => {
  // Determine color based on risk score
  const getColor = (riskScore: number) => {
    if (riskScore >= 60) return { main: brandColors.red }; // High risk - red (60-100)
    if (riskScore >= 30) return { main: brandColors.yellow }; // Medium risk - amber (30-59)
    return { main: brandColors.green }; // Low risk - green (0-29)
  };

  const data = [
    { name: 'filled', value: score },
    { name: 'empty', value: 100 - score },
  ];

  return (
    <div className="relative w-40 h-40 shrink-0">
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            innerRadius="75%"
            outerRadius="100%"
            paddingAngle={0}
            startAngle={90}
            endAngle={-270}
            dataKey="value"
          >
            {data.map((entry) => (
              <Cell key={`cell-${entry.name}`} fill={entry.name === 'empty' ? '#f0f0f2' : getColor(score).main} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
      <div className="absolute inset-0 flex items-center justify-center">
        <span className="text-3xl font-bold text-custom-black">{score}%</span>
      </div>
    </div>
  );
};

export default ChurnRiskIndicator;
